import React from 'react';
import ReactTooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import { TooltipContentWrapper, TooltipWrapper } from './Tooltip.styles';
import { TOOLTIP_MOBILE_DURATION } from '../../consts';

export interface IProps {
  id: string;
  parentRef: React.RefObject<HTMLDivElement>;
  showTooltip: boolean;
  isMobileOrTablet?: boolean;
  messageId?: string;
  invokerRef: HTMLDivElement | null;
}

function recalculateTop(inputRef: React.RefObject<HTMLDivElement>, top: number) {
  if (inputRef && inputRef.current) {
    const boundClient = inputRef.current.getBoundingClientRect();
    return top + boundClient.height / 2;
  }
  return 0;
}

export function Tooltip(props: IProps) {
  const { id, parentRef, showTooltip, messageId, isMobileOrTablet, invokerRef } = props;

  const closeAfterShow = () => () => {
    if (isMobileOrTablet && invokerRef) {
      setTimeout(ReactTooltip.hide, TOOLTIP_MOBILE_DURATION, invokerRef);
    }
  };

  if (showTooltip && messageId) {
    return (
      <TooltipWrapper>
        <ReactTooltip
          afterShow={closeAfterShow()}
          data-testid="tooltip"
          place="top"
          effect="solid"
          id={id}
          overridePosition={({ left, top }) => {
            const recalculatedTop = recalculateTop(parentRef, top);
            return { top: recalculatedTop > 0 ? recalculatedTop : top, left };
          }}
        >
          <TooltipContentWrapper className="tooltip-content-wrapper">
            <FormattedMessage id={messageId} />
          </TooltipContentWrapper>
        </ReactTooltip>
      </TooltipWrapper>
    );
  }

  return null;
}
